<template>
    <div class="bg-theme-black-transparent-80 top-0 left-0 w-full h-full fixed ">
        <div class="custom-loading-wrapper">
        <div class="bg-theme-green w-[90%] md:w-[500px] py-[40px] px-[20px] flex flex-col mx-auto rounded-[16px]">
                <p class="mb-[15px] mt-[5px] text-white text-center" v-html="message"></p>
                <div class="relative">
                    <div class="custom-loading">
                        <div class="bg-primary rect1"></div>
                        <div class="bg-primary rect2"></div>
                        <div class="bg-primary rect3"></div>
                        <div class="bg-primary rect4"></div>
                        <div class="bg-primary rect5"></div>
                    </div>
                </div>
        </div>
        </div>
    </div>
</template>

<script lang="ts">
  import { defineComponent, ref } from "vue"
  export default defineComponent({
    name: "QrCodeFullCard",
    setup() {
  
      return {
       
      };
    },
    props: {
      message: {
        type: Object,
        required: true,
        default: 'Please wait..'
      },
    }
  })

</script>

  <style scoped>
  .custom-loading-wrapper {
    position: fixed;
    text-align: center;
    display: flex;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: translateY(-50%);
  }
  .custom-loading {
      margin: 0px auto;
      width: 50px;
      height: 40px;
      text-align: center;
      font-size: 10px;
     
      position: relative;
      left: 0;
      right: 0;
  }
  
  .custom-loading > div {
    margin: 0 1px;
    background-color: #ffffff;
    height: 100%;
    width: 6px;
    display: inline-block;
    
    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
  }
  
  .custom-loading .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }
  
  .custom-loading .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }
  
  .custom-loading .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }
  
  .custom-loading .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }
  
  @-webkit-keyframes sk-stretchdelay {
    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  
    20% { -webkit-transform: scaleY(1.0) }
  }
  
  @keyframes sk-stretchdelay {
    0%, 40%, 100% { 
      transform: scaleY(0.4);
      -webkit-transform: scaleY(0.4);
    }  20% { 
      transform: scaleY(1.0);
      -webkit-transform: scaleY(1.0);
    }
  }
  </style>